"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = function () {
    return null;
};
exports.Menu.displayName = "Menu";
